// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelHeader{
    font-size: 0.8rem;
    font-weight: bold!important;
    text-align: left;
    background-color: rgba(0, 0, 0, 0.09);
    padding: 5px!important;
    margin: 4px 10px!important;
}

.fontSizeMobile{
    font-size: 0.8em!important;
}

.MuiOutlinedInput-input{
    padding: 5px!important;
}

.MuiInputBase-root{
    font-size: 0.8em;
}

.inputStyle{
    background-color: rgba(0, 0, 0, 0.09)!important;
    border: none!important;
    color: #CCCCCC;
    /* min-width: 147px !important; */
}

.labelNote{
    font-size: 0.6em!important;
    text-align: left!important;
    line-height: 0.5em!important;
}

.MuiFormControlLabel-root {
    text-align: left;
}

/* .MuiSvgIcon-root{
    width: 0.7em!important;
    height: 0.7em!important;
} */

.MuiOutlinedInput-adornedEnd{
    padding-right: 0!important;
}

.MuiTypography-root{
    font-size: 1.4em !important;
    margin: 0!important;
}

.MuiFormControlLabel-root{
    font-size: 0.8em!important;
    margin: 0!important;
}

.MuiButton-label{
    font-size: 0.8em!important;
}

/* .MuiButton-root{
    text-transform: none!important;
} */

.lightGrayColor{
    Color: dimgray !important;
    background-color: white !important;
}

.darkGrayColor{
    background-color: dimgray !important;
    color: white !important;
}

.MuiCheckbox-root{
    padding: 5px !important;
}
.MuiPickersBasePicker-pickerView{
    min-width: 295px !important;
}

.MuiToolbar-regular {
    min-height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/deviationRequestMobile/styling.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;IACtB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;GAGG;;AAEH;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".labelHeader{\n    font-size: 0.8rem;\n    font-weight: bold!important;\n    text-align: left;\n    background-color: rgba(0, 0, 0, 0.09);\n    padding: 5px!important;\n    margin: 4px 10px!important;\n}\n\n.fontSizeMobile{\n    font-size: 0.8em!important;\n}\n\n.MuiOutlinedInput-input{\n    padding: 5px!important;\n}\n\n.MuiInputBase-root{\n    font-size: 0.8em;\n}\n\n.inputStyle{\n    background-color: rgba(0, 0, 0, 0.09)!important;\n    border: none!important;\n    color: #CCCCCC;\n    /* min-width: 147px !important; */\n}\n\n.labelNote{\n    font-size: 0.6em!important;\n    text-align: left!important;\n    line-height: 0.5em!important;\n}\n\n.MuiFormControlLabel-root {\n    text-align: left;\n}\n\n/* .MuiSvgIcon-root{\n    width: 0.7em!important;\n    height: 0.7em!important;\n} */\n\n.MuiOutlinedInput-adornedEnd{\n    padding-right: 0!important;\n}\n\n.MuiTypography-root{\n    font-size: 1.4em !important;\n    margin: 0!important;\n}\n\n.MuiFormControlLabel-root{\n    font-size: 0.8em!important;\n    margin: 0!important;\n}\n\n.MuiButton-label{\n    font-size: 0.8em!important;\n}\n\n/* .MuiButton-root{\n    text-transform: none!important;\n} */\n\n.lightGrayColor{\n    Color: dimgray !important;\n    background-color: white !important;\n}\n\n.darkGrayColor{\n    background-color: dimgray !important;\n    color: white !important;\n}\n\n.MuiCheckbox-root{\n    padding: 5px !important;\n}\n.MuiPickersBasePicker-pickerView{\n    min-width: 295px !important;\n}\n\n.MuiToolbar-regular {\n    min-height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
